/* @flow */

import type { NETGEM_API_WISHLIST, NETGEM_API_WISHLIST_ITEM } from '../../libs/netgemLibrary/v8/types/Wishlist';

import { LoadableStatus } from '../loadable/loadable';
import { getHashFromDate } from '../request/cache';

type WishlistCacheType = { ids: Set<string>, items: NETGEM_API_WISHLIST };

const NOT_LOADED_WISHLIST: WishlistCacheType = { ids: new Set(), items: [] };

class WishlistCache {
  static cachedWishlist: WishlistCacheType = NOT_LOADED_WISHLIST;
  static hashCode: string | null = null;

  // $FlowFixMe[unsupported-syntax] Flow does not support symbols yet
  get [Symbol.toStringTag]() {
    return 'WishlistCache';
  }

  static reset: () => void = () => {
    WishlistCache.cachedWishlist = NOT_LOADED_WISHLIST;
    WishlistCache.hashCode = null;
  };

  static checkGet: (newWishlist: NETGEM_API_WISHLIST, status: LoadableStatus, ordered?: boolean) => WishlistCacheType = (newWishlist, status, ordered = false) => {
    if (status !== LoadableStatus.Loaded) {
      // Not loaded yet
      return NOT_LOADED_WISHLIST;
    }

    const dateItems = newWishlist.map((item) => {
      return { date: item.date };
    });
    const newHashCode = getHashFromDate(dateItems);

    if (newHashCode !== WishlistCache.hashCode) {
      // Cache items
      const items = [...newWishlist];
      if (ordered) {
        items.sort((a, b) => a.date.localeCompare(b.date));
      }

      // Cache Ids
      const ids: Set<string> = new Set();
      newWishlist.forEach((item: NETGEM_API_WISHLIST_ITEM) => ids.add(item.id));

      WishlistCache.hashCode = newHashCode;
      WishlistCache.cachedWishlist = { ids, items };
    }

    return WishlistCache.cachedWishlist;
  };
}

export default WishlistCache;
